<template>
  <div>
    <div v-swiper:mySwiper="swiperOption" v-if="swiperList.length > 1">
      <div class="swiper-wrapper" ref="wrapper">
        <div
          class="swiper-slide article_swiper"
          v-for="(item, index) in swiperList"
          :key="index"
          :data-url="item.url || ''"
        >
          <div class="dls-link">
            <img
              class="app-icon"
              :src="addOssParamsForcibly(item.image, 200)"
            />
            <div class="desc">
              <p v-if="item.type === 'title'" class="purple">
                {{ item.bigTitle }}
              </p>
              <p class="title">{{ item.title }}</p>
            </div>
          </div>
          <div class="btns-down" style="position: relative">
            {{ item.type === 'title' ? '立即加入' : '打开app' }}
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import { commonGetToken } from 'utils/tool.js'
import { getAdLists } from 'api/platform/mutualHelpV3.js'
import { addOssParamsForcibly } from 'utils/tool.js'
import { default as allToApp } from '@yxl/open-app'
import { addQueryToUrl } from 'app/frontend-lib/tools/utils.js'

export default {
  props: {
    errUrl: {
      type: String,
      default: ''
    }
  },
  name: 'swiper-head',
  data() {
    return {
      swiperList: [
        {
          app_title: '与2000万年轻人一起自我成长',
          author: '',
          brief: '',
          id: '',
          tag_id: '',
          themes_id: '',
          themes_title: '与2000万年轻人一起自我成长',
          title: '与2000万年轻人一起自我成长',
          user_id: '',
          viewnum: '',
          bigTitle: '壹心理App',
          image: 'https://lapp.xinli001.com/images/logo/logo9.png',
          type: 'title'
        }
      ],
      swiperOption: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          stopOnLastSlide: false
        },
        speed: 1000,
        loop: true,
        height: 60,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets'
        }
      }
    }
  },
  mounted() {
    commonGetToken(this).then(token => {
      this.fetchAd(
        {
          name: 'qa_m_download',
          size: 6,
          token: token || ''
        },
        () => {
          // 轮播图生成后手动配置toApp
          this.setToApp()
        }
      )
    })
  },
  methods: {
    addOssParamsForcibly,
    fetchAd(params, callback) {
      return getAdLists(params).then(res => {
        if (+res.code === 0) {
          let list = res.data || []
          list = list.filter(
            item => !this.swiperList.find(v => +v.id === +item.id)
          )
          this.swiperList = [...this.swiperList, ...list]
          callback && callback()
        }
      })
    },
    setToApp() {
      setTimeout(() => {
        const { wrapper } = this.$refs
        if (!wrapper) return
        const slides = wrapper.querySelectorAll('.swiper-slide')
        const errUrlObj = this.errUrl
          ? {
              errAndroidUrl: this.errUrl,
              errIosUrl: this.errUrl
            }
          : null
        for (let i = 0; i < slides.length; i++) {
          const el = slides[i]
          const url = el.getAttribute('data-url')
          const openAppConfig = {
            el,
            type: 'act',
            url: url ? url : addQueryToUrl(window.location.href, { node: 1 }),
            ...errUrlObj
          }
          console.info('openAppConfig:', openAppConfig)
          allToApp(openAppConfig)
        }
      }, 500)
    }
  }
}
</script>

<style>
.swiper-pagination-bullet {
  background: #c4c4c4 !important;
  opacity: 0.4 !important;
  width: 10px !important;
  height: 10px !important;
  border-radius: 50% !important;
}
.swiper-pagination-bullet-active {
  background: #ffffff !important;
  opacity: 0.6 !important;
  width: 25px !important;
  border-radius: 10px !important;
}
</style>

<style lang="scss" scoped>
@import '~lib/scss/functions.scss';

.swiper-wrapper {
  height: 126px !important;
  .swiper-slide {
    font-family: PingFangSC-Regular;
    width: 100%;
    background: #edf1f5;
  }
}
.swiper-pagination-bullets {
  bottom: 0 !important;
}

.article_swiper {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  .dls-link {
    display: flex !important;
    align-items: center;
    .app-icon {
      margin: 0 4px 0 20px;
      box-sizing: border-box;
      display: inline-block;
      max-width: 64px;
      min-width: 64px;
      height: 64px;
    }
    .desc {
      height: 100%;
      margin: 0 4px 0 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
      .purple {
        font-weight: bold;
        color: #333333;
      }
      .title {
        @include limitLine(2);
      }
    }
  }
  .btns-down {
    min-width: 112px;
    max-width: 112px;
    margin: 0 20px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border: 1px solid #6982fa;
    color: #6982fa;
    font-size: 24px;
    -webkit-border-radius: 8px;
    border-radius: 8px;
    background: 0 0;
  }
}
</style>
